import { createFileRoute } from "@tanstack/react-router";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { requirePerm } from "@/lib/auth/guards";
export const Route = createFileRoute("/_authenticated/pos")({
  beforeLoad: requirePerm("OPERATE_POS"),
  component: () => <PendingSurface titleKey="nav.pos" />,
});
